import 'core-js/modules/es6.reflect.construct.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.regexp.to-string.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.number.constructor.js';
import cx from 'classnames';
import * as React from 'react';
import { Keys, Classes, Icon, Intent, HTMLSelect, DISPLAYNAME_PREFIX } from '@blueprintjs/core';
import { TIMEPICKER, TIMEPICKER_ARROW_ROW, TIMEPICKER_INPUT_ROW, TIMEPICKER_HOUR, TIMEPICKER_MINUTE, TIMEPICKER_SECOND, TIMEPICKER_MILLISECOND, TIMEPICKER_ARROW_BUTTON, TIMEPICKER_DIVIDER_TEXT, TIMEPICKER_INPUT, TIMEPICKER_AMPM_SELECT } from './common/classes.js';
import { convert24HourMeridiem, getTimeInRange, areSameTime, getIsPmFrom24Hour, clone, isTimeInRange, get12HourFrom24Hour } from './common/dateUtils.js';
import { TimeUnit, getTimeUnitClassName, isTimeUnitValid, getTimeUnit, wrapTimeAtUnit, setTimeUnit, getDefaultMaxTime, getDefaultMinTime } from './common/timeUnit.js';
import { padWithZeroes } from './common/utils.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TimePrecision = {
  MILLISECOND: "millisecond",
  MINUTE: "minute",
  SECOND: "second"
}; // eslint-disable-next-line @typescript-eslint/no-redeclare

var TimePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props, context) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _super.call(this, props, context);

    _this.getInputChangeHandler = function (unit) {
      return function (e) {
        var text = getStringValueFromInputEvent(e);

        switch (unit) {
          case TimeUnit.HOUR_12:
          case TimeUnit.HOUR_24:
            _this.setState({
              hourText: text
            });

            break;

          case TimeUnit.MINUTE:
            _this.setState({
              minuteText: text
            });

            break;

          case TimeUnit.SECOND:
            _this.setState({
              secondText: text
            });

            break;

          case TimeUnit.MS:
            _this.setState({
              millisecondText: text
            });

            break;
        }
      };
    };

    _this.getInputBlurHandler = function (unit) {
      return function (e) {
        var _this$props$onBlur, _this$props;

        var text = getStringValueFromInputEvent(e);

        _this.updateTime(parseInt(text, 10), unit);

        (_this$props$onBlur = (_this$props = _this.props).onBlur) === null || _this$props$onBlur === void 0 ? void 0 : _this$props$onBlur.call(_this$props, e, unit);
      };
    };

    _this.getInputFocusHandler = function (unit) {
      return function (e) {
        var _this$props$onFocus, _this$props2;

        if (_this.props.selectAllOnFocus) {
          e.currentTarget.select();
        }

        (_this$props$onFocus = (_this$props2 = _this.props).onFocus) === null || _this$props$onFocus === void 0 ? void 0 : _this$props$onFocus.call(_this$props2, e, unit);
      };
    };

    _this.getInputKeyDownHandler = function (unit) {
      return function (e) {
        var _handleKeyEvent, _this$props$onKeyDown, _this$props3;

        handleKeyEvent(e, (_handleKeyEvent = {}, _defineProperty(_handleKeyEvent, Keys.ARROW_UP, function () {
          return _this.incrementTime(unit);
        }), _defineProperty(_handleKeyEvent, Keys.ARROW_DOWN, function () {
          return _this.decrementTime(unit);
        }), _defineProperty(_handleKeyEvent, Keys.ENTER, function () {
          e.currentTarget.blur();
        }), _handleKeyEvent));
        (_this$props$onKeyDown = (_this$props3 = _this.props).onKeyDown) === null || _this$props$onKeyDown === void 0 ? void 0 : _this$props$onKeyDown.call(_this$props3, e, unit);
      };
    };

    _this.getInputKeyUpHandler = function (unit) {
      return function (e) {
        var _this$props$onKeyUp, _this$props4;

        (_this$props$onKeyUp = (_this$props4 = _this.props).onKeyUp) === null || _this$props$onKeyUp === void 0 ? void 0 : _this$props$onKeyUp.call(_this$props4, e, unit);
      };
    };

    _this.handleAmPmChange = function (e) {
      var isNextPm = e.currentTarget.value === "pm";

      if (isNextPm !== _this.state.isPm) {
        var _this$state$value;

        var hour = convert24HourMeridiem((_this$state$value = _this.state.value) === null || _this$state$value === void 0 ? void 0 : _this$state$value.getHours(), isNextPm);

        _this.setState({
          isPm: isNextPm
        }, function () {
          return _this.updateTime(hour, TimeUnit.HOUR_24);
        });
      }
    };

    _this.incrementTime = function (unit) {
      return _this.shiftTime(unit, 1);
    };

    _this.decrementTime = function (unit) {
      return _this.shiftTime(unit, -1);
    };

    var value = props === null || props === void 0 ? void 0 : props.minTime;

    if ((props === null || props === void 0 ? void 0 : props.value) != null) {
      value = props.value;
    } else if ((props === null || props === void 0 ? void 0 : props.defaultValue) != null) {
      value = props.defaultValue;
    }

    _this.state = _this.getFullStateFromValue(value, props === null || props === void 0 ? void 0 : props.useAmPm);
    return _this;
  }

  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var shouldRenderMilliseconds = this.props.precision === TimePrecision.MILLISECOND;
      var shouldRenderSeconds = shouldRenderMilliseconds || this.props.precision === TimePrecision.SECOND;
      var hourUnit = this.props.useAmPm ? TimeUnit.HOUR_12 : TimeUnit.HOUR_24;
      var classes = cx(TIMEPICKER, this.props.className, _defineProperty({}, Classes.DISABLED, this.props.disabled));
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("div", {
        className: TIMEPICKER_ARROW_ROW
      }, this.maybeRenderArrowButton(true, hourUnit), this.maybeRenderArrowButton(true, TimeUnit.MINUTE), shouldRenderSeconds && this.maybeRenderArrowButton(true, TimeUnit.SECOND), shouldRenderMilliseconds && this.maybeRenderArrowButton(true, TimeUnit.MS)), /*#__PURE__*/React.createElement("div", {
        className: TIMEPICKER_INPUT_ROW
      }, this.renderInput(TIMEPICKER_HOUR, hourUnit, this.state.hourText), this.renderDivider(), this.renderInput(TIMEPICKER_MINUTE, TimeUnit.MINUTE, this.state.minuteText), shouldRenderSeconds && this.renderDivider(), shouldRenderSeconds && this.renderInput(TIMEPICKER_SECOND, TimeUnit.SECOND, this.state.secondText), shouldRenderMilliseconds && this.renderDivider("."), shouldRenderMilliseconds && this.renderInput(TIMEPICKER_MILLISECOND, TimeUnit.MS, this.state.millisecondText)), this.maybeRenderAmPm(), /*#__PURE__*/React.createElement("div", {
        className: TIMEPICKER_ARROW_ROW
      }, this.maybeRenderArrowButton(false, hourUnit), this.maybeRenderArrowButton(false, TimeUnit.MINUTE), shouldRenderSeconds && this.maybeRenderArrowButton(false, TimeUnit.SECOND), shouldRenderMilliseconds && this.maybeRenderArrowButton(false, TimeUnit.MS)));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didMinTimeChange = prevProps.minTime !== this.props.minTime;
      var didMaxTimeChange = prevProps.maxTime !== this.props.maxTime;
      var didBoundsChange = didMinTimeChange || didMaxTimeChange;
      var didPropValueChange = prevProps.value !== this.props.value;
      var shouldStateUpdate = didMinTimeChange || didMaxTimeChange || didBoundsChange || didPropValueChange;
      var value = this.state.value;

      if (didBoundsChange) {
        value = getTimeInRange(this.state.value, this.props.minTime, this.props.maxTime);
      }

      if (this.props.value != null && !areSameTime(this.props.value, prevProps.value)) {
        value = this.props.value;
      }

      if (shouldStateUpdate) {
        this.setState(this.getFullStateFromValue(value, this.props.useAmPm));
      }
    } // begin method definitions: rendering

  }, {
    key: "maybeRenderArrowButton",
    value: function maybeRenderArrowButton(isDirectionUp, timeUnit) {
      var _this2 = this;

      if (!this.props.showArrowButtons) {
        return null;
      }

      var classes = cx(TIMEPICKER_ARROW_BUTTON, getTimeUnitClassName(timeUnit));

      var onClick = function onClick() {
        return (isDirectionUp ? _this2.incrementTime : _this2.decrementTime)(timeUnit);
      }; // set tabIndex=-1 to ensure a valid FocusEvent relatedTarget when focused


      return /*#__PURE__*/React.createElement("span", {
        tabIndex: -1,
        className: classes,
        onClick: onClick
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: isDirectionUp ? "chevron-up" : "chevron-down"
      }));
    }
  }, {
    key: "renderDivider",
    value: function renderDivider() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ":";
      return /*#__PURE__*/React.createElement("span", {
        className: TIMEPICKER_DIVIDER_TEXT
      }, text);
    }
  }, {
    key: "renderInput",
    value: function renderInput(className, unit, value) {
      var isValid = isTimeUnitValid(unit, parseInt(value, 10));
      var isHour = unit === TimeUnit.HOUR_12 || unit === TimeUnit.HOUR_24;
      return /*#__PURE__*/React.createElement("input", {
        className: cx(TIMEPICKER_INPUT, _defineProperty({}, Classes.intentClass(Intent.DANGER), !isValid), className),
        onBlur: this.getInputBlurHandler(unit),
        onChange: this.getInputChangeHandler(unit),
        onFocus: this.getInputFocusHandler(unit),
        onKeyDown: this.getInputKeyDownHandler(unit),
        onKeyUp: this.getInputKeyUpHandler(unit),
        value: value,
        disabled: this.props.disabled,
        autoFocus: isHour && this.props.autoFocus
      });
    }
  }, {
    key: "maybeRenderAmPm",
    value: function maybeRenderAmPm() {
      if (!this.props.useAmPm) {
        return null;
      }

      return /*#__PURE__*/React.createElement(HTMLSelect, {
        className: TIMEPICKER_AMPM_SELECT,
        disabled: this.props.disabled,
        onChange: this.handleAmPmChange,
        value: this.state.isPm ? "pm" : "am"
      }, /*#__PURE__*/React.createElement("option", {
        value: "am"
      }, "AM"), /*#__PURE__*/React.createElement("option", {
        value: "pm"
      }, "PM"));
    } // begin method definitions: event handlers

  }, {
    key: "getFullStateFromValue",
    value: // begin method definitions: state modification

    /**
     * Generates a full ITimePickerState object with all text fields set to formatted strings based on value
     */
    function getFullStateFromValue(value, useAmPm) {
      var timeInRange = getTimeInRange(value, this.props.minTime, this.props.maxTime);
      var hourUnit = useAmPm ? TimeUnit.HOUR_12 : TimeUnit.HOUR_24;
      /* tslint:disable:object-literal-sort-keys */

      return {
        hourText: formatTime(timeInRange.getHours(), hourUnit),
        minuteText: formatTime(timeInRange.getMinutes(), TimeUnit.MINUTE),
        secondText: formatTime(timeInRange.getSeconds(), TimeUnit.SECOND),
        millisecondText: formatTime(timeInRange.getMilliseconds(), TimeUnit.MS),
        value: timeInRange,
        isPm: getIsPmFrom24Hour(timeInRange.getHours())
      };
      /* tslint:enable:object-literal-sort-keys */
    }
  }, {
    key: "shiftTime",
    value: function shiftTime(unit, amount) {
      if (this.props.disabled) {
        return;
      }

      var newTime = getTimeUnit(unit, this.state.value) + amount;
      this.updateTime(wrapTimeAtUnit(unit, newTime), unit);
    }
  }, {
    key: "updateTime",
    value: function updateTime(time, unit) {
      var newValue = clone(this.state.value);

      if (isTimeUnitValid(unit, time)) {
        setTimeUnit(unit, time, newValue, this.state.isPm);

        if (isTimeInRange(newValue, this.props.minTime, this.props.maxTime)) {
          this.updateState({
            value: newValue
          });
        } else {
          this.updateState(this.getFullStateFromValue(this.state.value, this.props.useAmPm));
        }
      } else {
        this.updateState(this.getFullStateFromValue(this.state.value, this.props.useAmPm));
      }
    }
  }, {
    key: "updateState",
    value: function updateState(state) {
      var newState = state;
      var hasNewValue = newState.value != null && !areSameTime(newState.value, this.state.value);

      if (this.props.value == null) {
        // component is uncontrolled
        if (hasNewValue) {
          newState = this.getFullStateFromValue(newState.value, this.props.useAmPm);
        }

        this.setState(newState);
      } else {
        // component is controlled, and there's a new value
        // so set inputs' text based off of _old_ value and later fire onChange with new value
        if (hasNewValue) {
          this.setState(this.getFullStateFromValue(this.state.value, this.props.useAmPm));
        } else {
          // no new value, this means only text has changed (from user typing)
          // we want inputs to change, so update state with new text for the inputs
          // but don't change actual value
          this.setState(_objectSpread(_objectSpread({}, newState), {}, {
            value: clone(this.state.value)
          }));
        }
      }

      if (hasNewValue) {
        var _this$props$onChange, _this$props5;

        (_this$props$onChange = (_this$props5 = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props5, newState.value);
      }
    }
  }]);

  return TimePicker;
}(React.Component);
TimePicker.defaultProps = {
  autoFocus: false,
  disabled: false,
  maxTime: getDefaultMaxTime(),
  minTime: getDefaultMinTime(),
  precision: TimePrecision.MINUTE,
  selectAllOnFocus: false,
  showArrowButtons: false,
  useAmPm: false
};
TimePicker.displayName = "".concat(DISPLAYNAME_PREFIX, ".TimePicker");

function formatTime(time, unit) {
  switch (unit) {
    case TimeUnit.HOUR_24:
      return time.toString();

    case TimeUnit.HOUR_12:
      return get12HourFrom24Hour(time).toString();

    case TimeUnit.MINUTE:
    case TimeUnit.SECOND:
      return padWithZeroes(time.toString(), 2);

    case TimeUnit.MS:
      return padWithZeroes(time.toString(), 3);

    default:
      throw Error("Invalid TimeUnit");
  }
}

function getStringValueFromInputEvent(e) {
  return e.target.value;
}

function handleKeyEvent(e, actions) {
  var preventDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  for (var _i = 0, _Object$keys = Object.keys(actions); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];

    var _key = Number(k); // HACKHACK: https://github.com/palantir/blueprint/issues/4165
    // eslint-disable-next-line deprecation/deprecation


    if (e.which === _key) {
      if (preventDefault) {
        e.preventDefault();
      }

      actions[_key]();
    }
  }
}

export { TimePicker, TimePrecision };
//# sourceMappingURL=timePicker.js.map
